<template>
  <!-- Dialog -->
  <v-dialog v-model="dialog" width="600" persistent>
    <v-card class="pa-6" min-height="500">
      <div
        class="font-18 font-w-700 mb-4 d-flex justify-space-between align-center"
      >
        <div>เลือกสาขา</div>
        <div>
          <v-btn icon @click="onClose()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <v-divider class="mt-3 mb-4"></v-divider>

      <!-- Form Select Branch -->
      <!-- ค้นหาจาก:  -->
      <v-layout align-center mb-4 wrap>
        <v-flex xs3 style="max-width:70px">ค้นหาจาก:</v-flex>
        <v-flex xs9 md3 class="pl-0 pl-sm-3 mb-2 mb-sm-0">
          <v-select
            v-model="form.branchType"
            :items="branchType"
            item-text="label"
            menu-props="offsetY"
            item-value="value"
            placeholder="รหัสสาขา"
            outlined
            dense
            color="var(--theme-color-one)"
            hide-details
            height="40"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4 class="pl-0 pl-sm-3 mb-2 mb-sm-0">
          <v-text-field
            v-model="form.branchNo"
            placeholder="ระบุข้อมูล"
            outlined
            prepend-inner-icon="mdi-magnify"
            dense
            hide-details
            color="var(--theme-color-one)"
            height="40"
          ></v-text-field>
        </v-flex>
        <v-flex class="flex mx-2 shrink">
          <v-btn
            outlined
            depressed
            dark block
            color="var(--theme-color-one)"
            @click="onSearch()"
          >
            ค้นหา
          </v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn
            outlined
            height="40"
            style="border-radius: 10px"
            color="#D8DDE1"
            @click="onReset"
          >
            <span style="color: var(--theme-color-two)">รีเซ็ต</span>
          </v-btn>
        </v-flex>
      </v-layout>

      <!-- ตัวกรอง: -->
      <!-- <v-layout align-center>
        <v-flex xs2>ตัวกรอง:</v-flex>
        <v-flex xs4 class="pl-3">
          <v-autocomplete
            v-model="form.provinceCode"
            :items="provinceList"
            item-text="label"
            item-value="label"
            menu-props="offsetY"
            placeholder="จังหวัด"
            outlined
            dense
            color="var(--theme-color-one)"
            hide-details
            height="40"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs4 class="pl-3">
          <v-autocomplete
            v-model="form.districtCode"
            :items="districtList"
            item-text="label"
            item-value="label"
            menu-props="offsetY"
            placeholder="เขต/อำเภอ"
            outlined
            dense
            color="var(--theme-color-one)"
            hide-details
            height="40"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs2 class="pl-3">
          <v-btn outlined depressed dark color="#A7B1BC" @click="onReset()">
            รีเซ็ต
          </v-btn>
        </v-flex>
      </v-layout> -->

      <!-- radio list -->
      <v-card style="maxHeight:285px; overflow-y: scroll; boxShadow: none;">
        <v-radio-group v-if="branchList.length > 0" v-model="form.branchName">
          <v-radio
            v-for="(item, i) in branchList"
            :key="i"
            color="var(--theme-color-one)"
            :label="item.BranchCodeMAP__c + ' ' + item.Name"
            :value="item.Id"
          >
            <template v-slot:label>
              <div class="font-14 font-w-500" style="color: #637381">
                {{ item.BranchCodeMAP__c + " " + item.Name }}
              </div>
            </template>
          </v-radio>
        </v-radio-group>

        <div v-else class="d-flex flex-column justify-center align-center">
          <v-img
            width="130"
            height="130"
            aspect-ratio="1"
            :src="require('../assets/img/NoSearchResult.png')"
          ></v-img>
          <div class="font-18 font-w-500" style="color: #919eab">ไม่พบสาขา</div>
        </div>
      </v-card>

      <v-layout
        class="mt-4"
        justify-end
        style="position: absolute; bottom: 20px; right: 20px"
      >
        <v-flex shrink class="mr-2">
          <v-btn width="120" text @click="onClose()"> ยกเลิก </v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn
            color="#4CA22F"
            dark
            width="120"
            block
            depressed
            style="border-radius: 10px"
            @click="onAccept()"
          >
            ยืนยัน
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import { controllerName, mainSite, logOutUrl } from "../store/constants";
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      branchType: [
        { label: "รหัสสาขา", value: "branchNo" },
        { label: "ชื่อสาขา", value: "branchName" },
      ],
      form: {
        branchType: "branchNo",
        branchNo: "",
        branchName: "",
        provinceCode: "",
        districtCode: "",
      },
      defaultData: [],
      branchList: [],
      provinceList: [],
      districtList: [],
    };
  },
  created() {
    this.getBranchList();
  },
  methods: {
    getBranchList() {
      this.$store.commit("General/setLoading");
      this.$lc.callApex(`${controllerName}.getBranchList`, (res, event) => {
        console.log("event: ", event);
        console.log("getBranchList: ", res);

        if (event.status && event.statusCode === 200 && res) {
          this.branchList = res.items;
          this.defaultData = res.items;
          this.districtList = res.districts;
          this.provinceList = res.provinces;
        }
        this.$store.commit("General/setLoading", false);
      });
    },
    onClose() {
      this.onReset();
      this.$emit("close");
    },
    onAccept() {
      if (!this.form.branchName) {
        this.$swal({
          title: "Warning",
          text: "กรุณาเลือกสาขา",
          icon: "warning",
          confirmButtonColor: "#C71010",
        });
        return;
      }
      this.$store.commit("General/setLoading");
      this.$lc.callApex(
        `${controllerName}.changeBranch`,
        {
          recordId: this.form.branchName,
        },
        (res, event) => {
          console.log("event: ", event);
          console.log("changeBranch: ", res);

          if (event.status && event.statusCode === 200 && res) {
            // this.$swal({
            //   title: "Success",
            //   text: "Change Branch Success",
            //   icon: "success",
            //   confirmButtonColor: "#C71010",
            // }).then(() => {
              this.$store.commit("General/setLoading", false);
              this.onReset();
              this.$emit("accept");
              this.setShow(false)
              this.reload();
            // });
          }
        }
      );
    },
    onReset() {
      this.form = {
        branchType: "branchNo",
        branchNo: "",
        branchName: "",
        provinceCode: "",
        districtCode: "",
      };
      this.branchList = this.defaultData;
    },
    onSearch() {
      // console.log(this.form);
      // branchNo
      if (
        this.form.branchNo &&
        this.form.provinceCode === "" &&
        this.form.districtCode === ""
      ) {
        // console.log("branchNo");
        this.branchList = this.defaultData.filter((item) => {
          return this.form.branchType === "branchNo"
            ? item.BranchCodeMAP__c.toUpperCase().includes(this.form.branchNo.toUpperCase())
            : item.Name.toUpperCase().includes(this.form.branchNo.toUpperCase());
        });
      }
      // branchNo && provinceCode
      else if (
        this.form.branchNo &&
        this.form.provinceCode &&
        this.form.districtCode === ""
      ) {
        // console.log("branchNo && provinceCode");
        this.branchList = this.defaultData.filter(
          (item) =>
            (this.form.branchType === "branchNo"
              ? item.BranchCodeMAP__c.includes(this.form.branchNo)
              : item.Name.includes(this.form.branchNo)) &&
            item.Province__c === this.form.provinceCode
        );
      }
      // branchNo && provinceCode && districtCode
      else if (
        this.form.branchNo &&
        this.form.provinceCode &&
        this.form.districtCode
      ) {
        // console.log("branchNo && provinceCode && districtCode");
        this.branchList = this.defaultData.filter(
          (item) =>
            (this.form.branchType === "branchNo"
              ? item.BranchCodeMAP__c.includes(this.form.branchNo)
              : item.Name.includes(this.form.branchNo)) &&
            item.Province__c === this.form.provinceCode &&
            item.SubDistrict__c === this.form.districtCode
        );
      }
      // provinceCode
      else if (
        this.form.branchNo === "" &&
        this.form.provinceCode &&
        this.form.districtCode === ""
      ) {
        // console.log("provinceCode");
        this.branchList = this.defaultData.filter(
          (item) => item.Province__c === this.form.provinceCode
        );
      }
      // provinceCode && districtCode
      else if (
        this.form.branchNo === "" &&
        this.form.provinceCode &&
        this.form.districtCode
      ) {
        // console.log("provinceCode && districtCode");
        this.branchList = this.defaultData.filter(
          (item) =>
            item.Province__c === this.form.provinceCode &&
            item.SubDistrict__c === this.form.districtCode
        );
      }
      // districtCode
      else if (
        this.form.branchNo === "" &&
        this.form.provinceCode === "" &&
        this.form.districtCode
      ) {
        // console.log("districtCode");
        this.branchList = this.defaultData.filter(
          (item) => item.SubDistrict__c === this.form.districtCode
        );
      } 
      // back to show all
      else{
        this.branchList = this.defaultData;
      }
    },
  },
};
</script>

<style></style>
